module.exports = __webpack_public_path__ + "static/img/pay-7.ae269dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay/pay-7.png
// module id = sMjm
// module chunks = 1